import {createAction, props} from '@ngrx/store';
import {EmployeeState} from './employee.model';

export const employeeSave = createAction(
    '[employee] Save',
    props<{employeeState: EmployeeState}>()
);

export const employeeReset = createAction('[employee] Reset');
